import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';
import { ThemeProvider } from './context/ThemeContext';
import Swal from 'sweetalert2';
import cookies from 'js-cookie';

axios.defaults.baseURL = process.env.REACT_APP_API
// axios.defaults.baseURL = 'https://api22.onrender.com';

// Check requests status after.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      console.error('No autorizado');
      console.log(error?.response?.data?.msg)
      if (error?.response?.data?.msg === 'Usuario Bloqueado.') {
        Swal.fire({
          icon: 'error',
          title: 'No autorizado',
          text: 'Tu usuario ha sido bloqueado o estás fuera de horario, contacta al administrador para más información.',
          confirmButtonText: 'OK'
        }).then(() => {
          cookies.remove('Token');
          cookies.remove('loggedAs');
          window.location.href = '/login';
        })
      }
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </BrowserRouter>
  // </React.StrictMode>
);